export class KeyPressService {
  private VALID_KEYCODES = ['Escape', 'Space', 'Enter'];
  private IGNORE_TAGS = ['INPUT', 'SELECT', 'TEXTAREA'];

  constructor() {
    this.handleKeyPresses();
  }

  handleKeyPresses() {
    document.onkeydown = (e: KeyboardEvent) => {
      if (!this.VALID_KEYCODES.includes(e.code)) {
        return;
      }

      const element = document.activeElement as HTMLElement;

      if (this.IGNORE_TAGS.includes(element.tagName)) {
        return;
      }

      const customEvent = new CustomEvent(`keypress_${e.code}`.toLowerCase(), {
        detail: {
          originalEvent: e,
          preventDefault: () => {
            e.preventDefault();
          },
          element,
        },
      });

      const prevented = !document.dispatchEvent(customEvent);

      if (prevented) {
        e.preventDefault();
      }
    };
  }
}
